import { Button } from '@/components/ui/button';
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogDescription,
	DialogFooter,
	DialogTrigger,
	DialogClose,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { useTranslation } from 'react-i18next';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { Form, FormField, FormItem, FormMessage } from '@/components/ui/form';
import useCreateList from '../hooks/useCreateList';

const ListAddModal = () => {
	const { t } = useTranslation();
	const { createList } = useCreateList();

	const listSchema = z.object({
		name: z.string().min(1, { message: t('common.error.required') }),
	});

	const form = useForm<z.infer<typeof listSchema>>({
		resolver: zodResolver(listSchema),
		defaultValues: {
			name: '',
		},
	});

	const onSubmit = (values: z.infer<typeof listSchema>) => {
		createList({ name: values.name });
	};

	return (
		<Dialog modal={true}>
			<DialogTrigger asChild className="w-full">
				<Button className="mb-6 w-full" variant="secondary">
					{t('home.createList')}
				</Button>
			</DialogTrigger>
			<DialogContent className="max-w-[95%] sm:max-w-[425px]">
				<DialogHeader>
					<DialogTitle>{t('list.form.title')}</DialogTitle>
					<DialogDescription>
						{t('list.form.description')}
					</DialogDescription>
				</DialogHeader>
				<Form {...form}>
					<form id="create" onSubmit={form.handleSubmit(onSubmit)}>
						<div className="w-full">
							<FormField
								control={form.control}
								name="name"
								render={({ field }) => (
									<FormItem>
										<Input
											id="name"
											label={t('list.form.name')}
											placeholder={t(
												'list.form.placeholder'
											)}
											className="w-full"
											{...field}
										/>
										<FormMessage />
									</FormItem>
								)}
							/>
						</div>
					</form>
				</Form>
				<DialogFooter className="gap-3 pt-4 sm:gap-0">
					<DialogClose asChild>
						<Button className="w-full" variant="outline">
							{t('common.cancel')}
						</Button>
					</DialogClose>
					<DialogClose asChild>
						<Button className="w-full" type="submit" form="create">
							{t('list.form.action')}
						</Button>
					</DialogClose>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default ListAddModal;
